import { Box, Typography } from "@mui/material";
import React from "react";
import {
  Legend,
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  Tooltip,
} from "recharts";
import { HandleSkeletion } from "../../../../../utils/constants";
import {
  CommonGrid2,
  DotColor,
} from "../../../../common-components/StyledComponents";
import { TooltipParagraph } from "../../style";

function Comparison({ matchedData, loading }) {
  const staticData = [
    {
      name: "Professionalism",
      candidate_score: 70,
      highest_score: 85,
      average_score: 60,
    },
    {
      name: "Education",
      candidate_score: 75,
      highest_score: 90,
      average_score: 65,
    },
    {
      name: "Experience",
      candidate_score: 80,
      highest_score: 95,
      average_score: 70,
    },
    {
      name: "Skill Alignment",
      candidate_score: 60,
      highest_score: 85,
      average_score: 68,
    },
    {
      name: "Leadership",
      candidate_score: 85,
      highest_score: 90,
      average_score: 72,
    },
  ];
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, candidate_score, highest_score, average_score } =
        payload[0].payload;
      return (
        <Box
          backgroundColor={"rgb(249 247 255)"}
          padding={"10px"}
          border={"1px solid rgb(127, 86, 217)"}
          borderRadius={"10px"}
        >
          <TooltipParagraph
            textAlign={"center"}
            fontWeight={700}
            fontSize={"15px"}
            color="#000"
          >
            {name}
          </TooltipParagraph>
          <CommonGrid2
            gap={"4px"}
            marginTop={"10px"}
            display={"flex"}
            flexDirection={"column"}
          >
            <TooltipParagraph
              color={"#6941C6"}
              display={"flex"}
              justifyContent={"space-between"}
              flexDirection={"row"}
              gap="10px"
            >
              Zahid Mays:{" "}
              <TooltipParagraph fontWeight={700}>
                {candidate_score}
              </TooltipParagraph>
            </TooltipParagraph>
            <TooltipParagraph
              color={"#667085a1"}
              display={"flex"}
              justifyContent={"space-between"}
              flexDirection={"row"}
              gap="10px"
            >
              Phoenix Baker:{" "}
              <TooltipParagraph fontWeight={700}>
                {highest_score}
              </TooltipParagraph>
            </TooltipParagraph>
            <TooltipParagraph
              color={"#F79009"}
              display={"flex"}
              justifyContent={"space-between"}
              flexDirection={"row"}
              gap="10px"
            >
              Freya Browing:{" "}
              <TooltipParagraph fontWeight={700}>
                {average_score}
              </TooltipParagraph>
            </TooltipParagraph>
          </CommonGrid2>
        </Box>
      );
    }
    return null;
  };

  const renderLegend = (props) => {
    const { payload } = props;
    return (
      <CommonGrid2
        justifyContent="center"
        display={"flex"}
        position={"relative"}
        top={"1.5rem"}
      >
        {payload.map((entry, index) => (
          <CommonGrid2
            key={`item-${index}`}
            alignItems={"center"}
            margin={"0 10px"}
            flexDirection={"row"}
            display={"flex"}
          >
            <DotColor
              color={entry.color}
              marginRight={"5px"}
              width={"8px"}
              height={"8px"}
            ></DotColor>
            <Typography fontSize={"14px"} fontWeight={600} color={"#475467"}>
              {entry.value}
            </Typography>
          </CommonGrid2>
        ))}
      </CommonGrid2>
    );
  };

  const CustomPolarRadiusAxisTick = (props) => {
    const { x, y, payload } = props;
    return (
      <text
        x={x}
        y={y}
        dy={16}
        textAnchor="middle"
        fill="#666"
        fontWeight="bold"
      >
        {payload.value}
      </text>
    );
  };

  return loading ? (
    <HandleSkeletion height={100} width={"100%"} />
  ) : (
    <Box
      sx={{
        width: "100%",
        mx: "auto",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        borderRadius: "12px",
        border: "1px solid #EAECF0 !important",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "0.5rem",
        padding: "10px 10px 2rem",
      }}
    >
      <RadarChart
        cx="50%"
        cy="50%"
        outerRadius="90%"
        width={600}
        height={350}
        data={staticData}
      >
        <PolarGrid />

        <PolarAngleAxis
          dataKey="name"
          tick={{ fontWeight: 600, fill: "#475467", dy: 5 }}
        />
        <PolarRadiusAxis
          angle={30}
          domain={[0, 100]}
          tick={CustomPolarRadiusAxisTick}
          axisLine={false}
        />
        <Radar
          name="Zahid Mays"
          dataKey="candidate_score"
          stroke="#6941C6"
          // fill="transparent"
          fillOpacity={0.2}
          strokeWidth={2}
        />
        <Radar
          name="Phoenix Baker"
          dataKey="highest_score"
          stroke="#667085a1"
          // fill="transparent"
          fillOpacity={0.2}
          strokeWidth={2}
        />
        <Radar
          name="Freya Browing"
          dataKey="average_score"
          stroke="#F79009"
          // fill="transparent"
          fillOpacity={0.1}
          strokeWidth={2}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend content={renderLegend} />
      </RadarChart>
    </Box>
  );
}

export default Comparison;
